import { cx } from "@emotion/css";
import { ChatbotProvider } from "src/components/GlobalChatbot/ChatbotContext";
import { ChatbotLauncher } from "src/components/GlobalChatbot/ChatbotLauncher";
import { ChatbotPanel } from "src/components/GlobalChatbot/ChatbotPanel";
import type { ChatbotAttachableQuestion } from "src/components/GlobalChatbot/types";
import { useChatbotUrlState } from "src/hooks/useChatbotUrlState";

export interface GlobalChatbotProps {
	className?: string;
	attachableQuestion?: ChatbotAttachableQuestion;
}

export const GlobalChatbot = ({
	className,
	attachableQuestion,
}: GlobalChatbotProps) => {
	const {
		isOpen,
		setIsOpen,
		isFullWidth,
		setIsFullWidth,
		activeConversationId,
		setActiveConversationId,
	} = useChatbotUrlState();

	return (
		<ChatbotProvider attachableQuestion={attachableQuestion}>
			<div className={cx("global-chatbot-root", className)}>
				{isOpen ? (
					<ChatbotPanel
						isFullWidth={isFullWidth}
						onToggleFullWidth={setIsFullWidth}
						activeConversationId={activeConversationId}
						onActiveConversationChange={setActiveConversationId}
						onClose={() => setIsOpen(false)}
					/>
				) : (
					<ChatbotLauncher onClick={() => setIsOpen(true)} />
				)}
			</div>
		</ChatbotProvider>
	);
};
